<mat-expansion-panel class="whiteExpanded" [expanded]="isPanelOpen">
  <mat-expansion-panel-header class="justify-content-between">
      <mat-panel-title class="main-font"> STATISTICHE </mat-panel-title>


        <button mat-raised-button *ngIf="!isPanelOpen" class="scrum-btn me-4" routerLink="bacheca" (click)="stopEventPropagation($event); goToScrum()">Vai a scrum</button>

  </mat-expansion-panel-header>

  <div class="row col-12 justify-content-between ">
    <div class="col-6 justify-content-start">
      <span >
        Lorem Ipsum è un testo segnaposto utilizzato nel settore della tipografia e della stampa. Lorem Ipsum è considerato il testo segnaposto standard sin dal sedicesimo secolo, quando un anonimo tipografo prese una cassetta di caratteri e li assemblò per preparare un testo campione. È sopravvissuto non solo a più di cinque secoli, ma anche al passaggio alla videoimpaginazione, pervenendoci sostanzialmente inalterato. Fu reso popolare, negli anni ’60, con la diffusione dei fogli di caratteri trasferibili “Letraset”, che contenevano passaggi del Lorem Ipsum, e più recentemente da software di impaginazione come Aldus PageMaker, che includeva versioni del Lorem Ipsum.        </span>
    </div>

    <div class="col-6 justify-content-between">
      <div class="row g-4 justify-content-between">
        <div class="col-4">
          <button class="scrum-btn" type="button"  data-bs-toggle="dropdown">
            Da sprint
            <svg class="button-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          <ul class="dropdown-menu">
            <li  *ngFor="let sprint of sprints; index as i;">
              <a class="dropdown-item"> {{sprint.value}} </a>
            </li>
          </ul>
        </div>

        <div class="col-4">
          <button class="scrum-btn " type="button" data-bs-toggle="dropdown">
            A sprint 
            <svg class="button-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          <ul class="dropdown-menu">
            <li  *ngFor="let sprint of sprints; index as i;">
              <a class="dropdown-item"> {{sprint.value}} </a>
            </li>
          </ul>
        </div>

        <div class="col-4">
          <button class="scrum-btn" type="button" >
            Vai a scrum
          </button>
        </div>
  
        <div class="row g-4 mt-1">
          <div class="col-4">
            <mat-card class="count-card" routerLink="../condivisione">
                <mat-card-title class="h5 text-center">SP FATTI</mat-card-title>
                <mat-card-content class=" h1 text-center">
                  0
                </mat-card-content>
            </mat-card>
          </div>


          <div class="col-4">
            <mat-card class="count-card" routerLink="../condivisione">
                <mat-card-title class="h5 text-center">CAPACITY TOTALE</mat-card-title>
                <mat-card-content class=" h1 text-center">
                  0
                </mat-card-content>
            </mat-card>
          </div>

          <div class="col-4">
            <mat-card class="count-card" routerLink="../consapevolezza">
              <mat-card-title class="h5 text-center">VELOCITY MEDIA</mat-card-title>
              <mat-card-content class=" h1 text-center">
                0
              </mat-card-content>
            </mat-card>
          </div>

          <div class="col-4">
            <mat-card class="count-card" routerLink="../competenze">
                <mat-card-title class="h5 text-center">SP SENZA RESIDUO</mat-card-title>
                <mat-card-content class=" h1 text-center">
                  0
                </mat-card-content>
            </mat-card>
          </div>

          <div class="col-4">
            <mat-card class="count-card" routerLink="../competenze">
              <mat-card-title class="h5 text white-space: normal; ">% DEGLI SP SVILUPPATORE</mat-card-title>
              <mat-card-content class=" h1 text-center">
                0
              </mat-card-content>
            </mat-card>
          </div>
        

          <div class="col-4">
            <mat-card class="count-card" routerLink="../competenze">
              <mat-card-title class="h5 text-center">VELOCITY MEDIA CLIENTE</mat-card-title>
              <mat-card-content class=" h1 text-center">
                0
              </mat-card-content>
            </mat-card>
          </div>

        </div>
      </div>
    </div>

    <div class="col-6">
      <canvas class="chart" baseChart [data]="barChartData" [options]="barChartOptions"
      [type]="barChartType"(chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)" >
      </canvas>
    </div>
  </div>
</mat-expansion-panel>
